export default "/virtual-lobby";
